interface Locales {
    [language: string]: 'en' | 'fr' | 'ar';
}

export const LOCALES: Locales = {
    ENGLISH: 'en',
    FRENCH:  'fr',
    ARABIC:  'ar',
};
